import { fulfilled, pending, rejected } from '../../../utils';
import { COMMENT_APPLICATION } from '../../actions/actiontype';

const initialState = {
  status: '',
  loading: false,
  message: '',
  data: '',
  error: '',
};

const commentReducer = (state = initialState, action) => {
  switch (action.type) {
    case pending(COMMENT_APPLICATION):
      return {
        ...state,
        loading: true,
        message: '',
        error: '',
      };
    case fulfilled(COMMENT_APPLICATION):
      return {
        ...state,
        loading: false,
        status: action.payload.status,
        message: action.payload.message,
        data: action.payload.data,
      };
    case rejected(COMMENT_APPLICATION):
      const status = action.payload.response.status;
      return {
        ...state,
        loading: false,
        message: '',
        error:
          status === 500
            ? 'Something went wrong. Please try again later'
            : action?.payload?.response.data.message,
      };
    default:
      return state;
  }
};

export default commentReducer;
